import periodCardComponent from './periodCard.component';
import periodCardIcon from './periodCardIcon/periodCardIcon';

let periodCardModule = angular.module('vacations-absences.periodCard', [
  periodCardIcon
])

.component('periodCard', periodCardComponent)

.name;

export default periodCardModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/myVacations/periodList/periodCard/periodCard.js